var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":"/details"}},[_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/details"}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{staticStyle:{"height":"80%","width":"80%"},attrs:{"src":require("@src/assets/navbar/details-list.svg")}})]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('navbar.details')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }